<template>
    <div :style="sidePanelsStyle"
        :id="'sidePanel_' + side"
        data-compType="sidePanels"
        class="div_panels_container"
        :class="{
            div_panels_container_open : (GET_activeSp != '')
        }"
        @mouseenter="spsEnter()"
    >
        <!-- desabilitei para poder usar o debug tools para inspect o html do painel -->
        <!-- @mouseleave="spsLeave()" -->
        
        <div v-for="panel in panels.filter(panel => (panel.side == side))"
            :key = "'div_' + panel.label + '_panel'"
            v-bind="{
                'data-compType' : 'sidePanelsItem',
            }"
            :id="'div_' + panel.id"
            :class="[
                'div_panel',
                (side == gConsts.ui.sidePanel.sides.LEFT) ? 'div_panel_left' : 'div_panel_right'
            ]"
            :style="{
                width : ((panel.id == GET_activeSp) ? panel.width : colapsedWidth) + 'px',
                background: GET_colorTheme.sidePanels,
            }"
        >
            <div 
                class="div_panelHandle"                
                @click="sphClick(panel.id)"
                @mouseenter="sphEnter(panel.id)"
                :data-active="panel.id == GET_activeSp"
            >
                <!-- @mouseleave="sphLeave()" -->
                <span class="span_panelIcon"> {{ panel.icon }}</span>
                <span class="span_panelLabel">{{ panel.label }}</span>
            </div>
                
            <component 
                :is="panel.comp"
                :ref="panel.label"
                :panelId="panel.id"
                :parent="id"
                :label="panel.label"
                :active="(GET_activeSp == panel.id)"
                :style="{ gridArea: 'panelContent' }"
            ></component>
        </div>
    </div>
</template>

// =========================================================================================
// =========================================================================================

<script>
import imgListCMP     from './imgList.vue';
import annotationsCMP from './annotations/annotations.vue';
import novoAnotacoesCMP from './relatorioDinamico/novoAnotacoes.vue';
import relatorioDinamicoCMP from './relatorioDinamico/relatorioDinamico.vue';
import relatorioCMP   from './relatorio.vue';
import configCMP      from './config.vue';

import { mapActions, mapGetters, mapState } from 'vuex';
import { gConsts } from '@/globals/gConsts';

// =========================================================================================

export default {
    name : 'sidePanelsCMP',
    components: {
            imgListCMP,
            annotationsCMP,
            novoAnotacoesCMP,
            relatorioDinamicoCMP,
            relatorioCMP,
            configCMP
    }, 

    // -----------------------------------------------------------------

    props: {    
        id     : String,
        panels : Array ,
        side   : String
    }, 

    // -----------------------------------------------------------------
    
    data () {
        return {
            colapsedWidth : 30,
            gConsts : gConsts,
            timeouts : {
                spsCollapseId : -1, 
                spActivateId  : -1
            }
        }
    },

    // -----------------------------------------------------------------

    computed: {  
        ...mapState([            
        ]),

        // -----------------------------------------------------------------

        ...mapGetters([
            'GET_togglesNodeSearch',
            'GET_colorTheme',
            'GET_activeSp',
        ]),



        // -----------------------------------------------------------------

        sidePanelsStyle() {
            var styleObj = {
                position : 'absolute',
                top      : '0px',
                zIndex   : 100,
                gridTemplateColumns : 'repeat(' + this.panels.length + ', auto)',
            }

            if (this.GET_togglesNodeSearch) {
                styleObj['opacity'] = 0.9;
            }

            switch (this.side) {
                case this.gConsts.ui.sidePanel.sides.RIGHT : styleObj['right'] = '0px'; break;
                case this.gConsts.ui.sidePanel.sides.LEFT  : styleObj['left' ] = '0px'; break;
            }
            return styleObj;
        },
        
    },

    // -----------------------------------------------------------------

    methods: {
        ...mapActions([
            'ACT_uiUpdate'
        ]),

        // -----------------------------------------------------------------

        spsEnter() { 
            console.log('spsEnter');
            clearTimeout(this.timeouts.spsCollapseId); 
        },

        // -----------------------------------------------------------------

        spsResetCollapse(timeout) {
            clearTimeout(this.timeouts.spsCollapseId);
            this.timeouts.spsCollapseId = setTimeout(() => {
                this.ACT_uiUpdate({ sidePanels : { activeSp : '' } });
            }, timeout ? timeout : gConsts.ui.sidePanel.timeouts.COLLAPSE);
        },

        // -----------------------------------------------------------------

        spsLeave(timeout) {
            console.log('spsLeave');
            this.timeouts.spsCollapseId = setTimeout(() => {
                this.ACT_uiUpdate({ sidePanels : { activeSp : '' } });
            }, timeout ? timeout : gConsts.ui.sidePanel.timeouts.COLLAPSE);
        },

        // -----------------------------------------------------------------

        sphClick(panelId) {
            console.log('sphClick');
            var activePanelId = (this.GET_activeSp == panelId) ? '' : panelId;
            clearTimeout(this.timeouts.spActivateId);
            this.ACT_uiUpdate({ sidePanels : { activeSp : activePanelId } });
        },

        // -----------------------------------------------------------------

        sphEnter(panelId) {
            console.log('sphEnter', panelId);
            if (panelId != this.GET_activeSp) {
                clearTimeout(this.timeouts.spActivateId);
                // Restore original behavior: activate panel after a short delay
                this.timeouts.spActivateId = setTimeout(() => {
                    this.ACT_uiUpdate({ sidePanels : { activeSp : panelId } });
                }, gConsts.ui.sidePanel.timeouts.ACTIVATE);
            }
        },

        // -----------------------------------------------------------------

        sphLeave() { 
            console.log('sphLeave');
            clearTimeout(this.timeouts.spActivateId); 
        },

    },

    // -----------------------------------------------------------------

    created() {
    },

    // -----------------------------------------------------------------

    mounted() {
        // if (this.side == this.gConsts.ui.sidePanel.sides.LEFT) {
        //     this.panels.reverse();
        // }
    }




}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>

.div_panels_container {
    width: fit-content;
    height: 100%;
    display : grid;
    grid-template-rows : auto;
    grid-gap: 2px;
    margin : 0px 0px;
    opacity: 0.9;
}

.div_panels_container_open {
    transition: opacity 0.4s ease-out;
    opacity: 0.5;
}

.div_panels_container_open:hover {
    opacity: 0.9;
}

.div_panel {
/*    background: rgba(243, 243, 243, 1); */
    display: grid;
    overflow: hidden;
    grid-column-gap: 2px;
    transition: width 0.3s ease-out;
    box-shadow: 1px 0px 5px -2px #000000;
}

.div_panel_left {
    grid-template-columns : auto 30px;
    grid-template-areas : "panelContent panelHandle";
}

.div_panel_right {
    grid-template-columns : 30px auto;
    grid-template-areas : "panelHandle panelContent";
}

.div_panelHandle {
/*    background: rgba(211, 211, 211, 0.1); */
    grid-area: panelHandle;
    display: grid;
    border-radius: 5% 5%;
    grid-template-rows: 40px auto;
    grid-template-areas:
        "panelIcon"
        "panelLabel";
    box-shadow: 1px 0px 5px -2px #000000;

    background: #eeeeee;
}

.div_panelHandle[data-active="true"] {
    color: white;
    background: #2B536ACC;
}

.span_panelIcon {
    cursor: default; 
    grid-area: panelIcon;
    margin-top: 10px;
    opacity: 1;
}

.span_panelLabel {
    font-family: 'Inter', sans-serif;
    letter-spacing: 0.05em;
    cursor: default; 
    grid-area: panelLabel;
    font-weight: bolder; 
    transform: scale(-1, -1); 
    writing-mode: vertical-lr; 
    text-align: right;    
    margin-right: 6px;
    margin-top: 10px;
}




</style>